
(() => { if (window.BEAEPAGEJS === undefined) {
            window.BEAEPAGEJS = [];
          }

          if(window.beaePageSetting == undefined) {
            window.beaePageSetting = {};
          }
          
          window.beaePageSetting.pageId = "69423205d47630c75700ca15";
              window.beaePageSetting.pageTitle = "G/Fore"; 
              window.beaePageSetting.pageType = "product";

          let js_5BTSUHTI = () => { let BeaeUseHooks = {};
      try {
        let argid = 'beae-75hri2yusection-js',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-75hri2yu',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-75hri2yu');
        args.el = args.els[0];
        ((t) => { var o;if((o=t.el.querySelector(".beae-grid-system"))==null||o.addEventListener("scroll",a=>{var r,l;let n=a.target;if(!n.classList.contains("beae-grid-carousel"))return;let s=Math.round((n.scrollLeft+n.querySelector(".beae-grid-carousel__snaps").offsetLeft)/(n.offsetWidth*.8))+1;(r=t.el.querySelector(".beae-grid-carousel__pagination div.active"))==null||r.classList.remove("active"),(l=t.el.querySelector('.beae-grid-carousel__pagination div[data-index="'+s+'"]'))==null||l.classList.add("active")}),t.mode.value=="live"){const a=t.el.querySelector('.beae-section-background-video[data-device="desktop"]'),n=t.el.querySelector('.beae-section-background-video[data-device="mobile"]'),s=[];window.BEAEVIDEO&&window.BEAEVIDEO.convertBackgroundSection&&(window.innerWidth>=768?a&&window.BEAEVIDEO.convertBackgroundSection(t.optionsVideo,a)&&s.push("desktop"):n&&window.BEAEVIDEO.convertBackgroundSection(t.optionsVideoMobile,n)&&s.push("mobile")),(a||n)&&window.addEventListener("resize",()=>{if(window.BEAEVIDEO&&window.BEAEVIDEO.convertBackgroundSection){if(!s.includes("desktop")&&window.innerWidth>=768&&a){const r=window.BEAEVIDEO.convertBackgroundSection(t.optionsVideo,a);r&&(a.innerHTML=r.html,s.push("desktop"))}if(!s.includes("mobile")&&window.innerWidth<768&&n){const r=window.BEAEVIDEO.convertBackgroundSection(t.optionsVideoMobile,n);r&&(n.innerHTML=r.html,s.push("mobile"))}}})}t.el.querySelectorAll(".beae-text-highlight").forEach(a=>{new IntersectionObserver((s,r)=>{s.forEach(l=>{l.isIntersecting&&(l.target.querySelectorAll("path, line").forEach(c=>{c.style.strokeDasharray=parseFloat(c.getAttribute("data-dash-ratio")*l.target.offsetWidth*2)+"px, 999999px"}),r.unobserve(l.target))})},{root:document,rootMargin:"0px 0px -40%"}).observe(a)}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-75hri2yu: ', ex)
      };
    

      try {
        let argid = 'beae-75hri2yusection-slide-show',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-75hri2yu',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-75hri2yu');
        args.el = args.els[0];
        ((g) => { window.BeaeSlider&&!g.noRunJs&&window.BeaeSlider(g) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-75hri2yu: ', ex)
      };
    

      try {
        let argid = 'beae-cxi5krg7block-text',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-cxi5krg7',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-cxi5krg7');
        args.el = args.els[0];
        ((P) => { var I;let O=(I=P.el)==null?void 0:I.querySelectorAll(".beae-x-text a");O==null||O.forEach(z=>{let H=z==null?void 0:z.getAttribute("href");z&&P.mode.value!=="builder"&&(H!=null&&H.includes("#"))&&z.addEventListener("click",A=>{let R=document.querySelector(H+","+(H==null?void 0:H.replace("#",".")));if(R)return R.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),A.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-cxi5krg7: ', ex)
      };
    

      try {
        let argid = 'beae-umenbsufblock-text',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-umenbsuf',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-umenbsuf');
        args.el = args.els[0];
        ((P) => { var I;let O=(I=P.el)==null?void 0:I.querySelectorAll(".beae-x-text a");O==null||O.forEach(z=>{let H=z==null?void 0:z.getAttribute("href");z&&P.mode.value!=="builder"&&(H!=null&&H.includes("#"))&&z.addEventListener("click",A=>{let R=document.querySelector(H+","+(H==null?void 0:H.replace("#",".")));if(R)return R.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),A.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-umenbsuf: ', ex)
      };
    

      try {
        let argid = 'beae-5qrbqxc2block-text',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-5qrbqxc2',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-5qrbqxc2');
        args.el = args.els[0];
        ((P) => { var I;let O=(I=P.el)==null?void 0:I.querySelectorAll(".beae-x-text a");O==null||O.forEach(z=>{let H=z==null?void 0:z.getAttribute("href");z&&P.mode.value!=="builder"&&(H!=null&&H.includes("#"))&&z.addEventListener("click",A=>{let R=document.querySelector(H+","+(H==null?void 0:H.replace("#",".")));if(R)return R.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),A.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-5qrbqxc2: ', ex)
      };
    

      try {
        let argid = 'beae-8t4yrdvdblock-text',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-8t4yrdvd',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-8t4yrdvd');
        args.el = args.els[0];
        ((P) => { var I;let O=(I=P.el)==null?void 0:I.querySelectorAll(".beae-x-text a");O==null||O.forEach(z=>{let H=z==null?void 0:z.getAttribute("href");z&&P.mode.value!=="builder"&&(H!=null&&H.includes("#"))&&z.addEventListener("click",A=>{let R=document.querySelector(H+","+(H==null?void 0:H.replace("#",".")));if(R)return R.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),A.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-8t4yrdvd: ', ex)
      };
    

      try {
        let argid = 'beae-bgu1v54bblock-text',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-bgu1v54b',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-bgu1v54b');
        args.el = args.els[0];
        ((P) => { var I;let O=(I=P.el)==null?void 0:I.querySelectorAll(".beae-x-text a");O==null||O.forEach(z=>{let H=z==null?void 0:z.getAttribute("href");z&&P.mode.value!=="builder"&&(H!=null&&H.includes("#"))&&z.addEventListener("click",A=>{let R=document.querySelector(H+","+(H==null?void 0:H.replace("#",".")));if(R)return R.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),A.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-bgu1v54b: ', ex)
      };
    

      try {
        let argid = 'beae-tj001pcxblock-text',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-tj001pcx',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-tj001pcx');
        args.el = args.els[0];
        ((P) => { var I;let O=(I=P.el)==null?void 0:I.querySelectorAll(".beae-x-text a");O==null||O.forEach(z=>{let H=z==null?void 0:z.getAttribute("href");z&&P.mode.value!=="builder"&&(H!=null&&H.includes("#"))&&z.addEventListener("click",A=>{let R=document.querySelector(H+","+(H==null?void 0:H.replace("#",".")));if(R)return R.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),A.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-tj001pcx: ', ex)
      };
    

      try {
        let argid = 'beae-gt4tgejfblock-text',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-gt4tgejf',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-gt4tgejf');
        args.el = args.els[0];
        ((P) => { var I;let O=(I=P.el)==null?void 0:I.querySelectorAll(".beae-x-text a");O==null||O.forEach(z=>{let H=z==null?void 0:z.getAttribute("href");z&&P.mode.value!=="builder"&&(H!=null&&H.includes("#"))&&z.addEventListener("click",A=>{let R=document.querySelector(H+","+(H==null?void 0:H.replace("#",".")));if(R)return R.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),A.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-gt4tgejf: ', ex)
      };
    

      try {
        let argid = 'beae-7rtzo112block-text',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-7rtzo112',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-7rtzo112');
        args.el = args.els[0];
        ((P) => { var I;let O=(I=P.el)==null?void 0:I.querySelectorAll(".beae-x-text a");O==null||O.forEach(z=>{let H=z==null?void 0:z.getAttribute("href");z&&P.mode.value!=="builder"&&(H!=null&&H.includes("#"))&&z.addEventListener("click",A=>{let R=document.querySelector(H+","+(H==null?void 0:H.replace("#",".")));if(R)return R.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),A.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-7rtzo112: ', ex)
      };
    

      try {
        let argid = 'beae-yobgfm6ublock-text',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-yobgfm6u',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-yobgfm6u');
        args.el = args.els[0];
        ((P) => { var I;let O=(I=P.el)==null?void 0:I.querySelectorAll(".beae-x-text a");O==null||O.forEach(z=>{let H=z==null?void 0:z.getAttribute("href");z&&P.mode.value!=="builder"&&(H!=null&&H.includes("#"))&&z.addEventListener("click",A=>{let R=document.querySelector(H+","+(H==null?void 0:H.replace("#",".")));if(R)return R.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),A.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-yobgfm6u: ', ex)
      };
    

      try {
        let argid = 'beae-exbzzdvoblock-text',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-exbzzdvo',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-exbzzdvo');
        args.el = args.els[0];
        ((P) => { var I;let O=(I=P.el)==null?void 0:I.querySelectorAll(".beae-x-text a");O==null||O.forEach(z=>{let H=z==null?void 0:z.getAttribute("href");z&&P.mode.value!=="builder"&&(H!=null&&H.includes("#"))&&z.addEventListener("click",A=>{let R=document.querySelector(H+","+(H==null?void 0:H.replace("#",".")));if(R)return R.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),A.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-exbzzdvo: ', ex)
      };
    

      try {
        let argid = 'beae-x6txrk44block-text',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-x6txrk44',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-x6txrk44');
        args.el = args.els[0];
        ((P) => { var I;let O=(I=P.el)==null?void 0:I.querySelectorAll(".beae-x-text a");O==null||O.forEach(z=>{let H=z==null?void 0:z.getAttribute("href");z&&P.mode.value!=="builder"&&(H!=null&&H.includes("#"))&&z.addEventListener("click",A=>{let R=document.querySelector(H+","+(H==null?void 0:H.replace("#",".")));if(R)return R.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),A.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-x6txrk44: ', ex)
      };
    

      try {
        let argid = 'beae-y3peuatyblock-text',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-y3peuaty',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-y3peuaty');
        args.el = args.els[0];
        ((P) => { var I;let O=(I=P.el)==null?void 0:I.querySelectorAll(".beae-x-text a");O==null||O.forEach(z=>{let H=z==null?void 0:z.getAttribute("href");z&&P.mode.value!=="builder"&&(H!=null&&H.includes("#"))&&z.addEventListener("click",A=>{let R=document.querySelector(H+","+(H==null?void 0:H.replace("#",".")));if(R)return R.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),A.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-y3peuaty: ', ex)
      };
    

      try {
        let argid = 'beae-ow7dka3bsection-js',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-ow7dka3b',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-ow7dka3b');
        args.el = args.els[0];
        ((t) => { var o;if((o=t.el.querySelector(".beae-grid-system"))==null||o.addEventListener("scroll",a=>{var r,l;let n=a.target;if(!n.classList.contains("beae-grid-carousel"))return;let s=Math.round((n.scrollLeft+n.querySelector(".beae-grid-carousel__snaps").offsetLeft)/(n.offsetWidth*.8))+1;(r=t.el.querySelector(".beae-grid-carousel__pagination div.active"))==null||r.classList.remove("active"),(l=t.el.querySelector('.beae-grid-carousel__pagination div[data-index="'+s+'"]'))==null||l.classList.add("active")}),t.mode.value=="live"){const a=t.el.querySelector('.beae-section-background-video[data-device="desktop"]'),n=t.el.querySelector('.beae-section-background-video[data-device="mobile"]'),s=[];window.BEAEVIDEO&&window.BEAEVIDEO.convertBackgroundSection&&(window.innerWidth>=768?a&&window.BEAEVIDEO.convertBackgroundSection(t.optionsVideo,a)&&s.push("desktop"):n&&window.BEAEVIDEO.convertBackgroundSection(t.optionsVideoMobile,n)&&s.push("mobile")),(a||n)&&window.addEventListener("resize",()=>{if(window.BEAEVIDEO&&window.BEAEVIDEO.convertBackgroundSection){if(!s.includes("desktop")&&window.innerWidth>=768&&a){const r=window.BEAEVIDEO.convertBackgroundSection(t.optionsVideo,a);r&&(a.innerHTML=r.html,s.push("desktop"))}if(!s.includes("mobile")&&window.innerWidth<768&&n){const r=window.BEAEVIDEO.convertBackgroundSection(t.optionsVideoMobile,n);r&&(n.innerHTML=r.html,s.push("mobile"))}}})}t.el.querySelectorAll(".beae-text-highlight").forEach(a=>{new IntersectionObserver((s,r)=>{s.forEach(l=>{l.isIntersecting&&(l.target.querySelectorAll("path, line").forEach(c=>{c.style.strokeDasharray=parseFloat(c.getAttribute("data-dash-ratio")*l.target.offsetWidth*2)+"px, 999999px"}),r.unobserve(l.target))})},{root:document,rootMargin:"0px 0px -40%"}).observe(a)}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-ow7dka3b: ', ex)
      };
    

      try {
        let argid = 'beae-9xj94skublock-text',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-9xj94sku',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-9xj94sku');
        args.el = args.els[0];
        ((P) => { var I;let O=(I=P.el)==null?void 0:I.querySelectorAll(".beae-x-text a");O==null||O.forEach(z=>{let H=z==null?void 0:z.getAttribute("href");z&&P.mode.value!=="builder"&&(H!=null&&H.includes("#"))&&z.addEventListener("click",A=>{let R=document.querySelector(H+","+(H==null?void 0:H.replace("#",".")));if(R)return R.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),A.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-9xj94sku: ', ex)
      };
    

      try {
        let argid = 'beae-doaeonaablock-text',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-doaeonaa',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-doaeonaa');
        args.el = args.els[0];
        ((P) => { var I;let O=(I=P.el)==null?void 0:I.querySelectorAll(".beae-x-text a");O==null||O.forEach(z=>{let H=z==null?void 0:z.getAttribute("href");z&&P.mode.value!=="builder"&&(H!=null&&H.includes("#"))&&z.addEventListener("click",A=>{let R=document.querySelector(H+","+(H==null?void 0:H.replace("#",".")));if(R)return R.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),A.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-doaeonaa: ', ex)
      };
    

      try {
        let argid = 'beae-jbezt11rbutton-js',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-jbezt11r',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-jbezt11r');
        args.el = args.els[0];
        ((data) => { let buttonElm=data.el.querySelector("a.beae-button-js");buttonElm==null||buttonElm.addEventListener("click",e=>{var n,t;let extOptions={};if(data.extendOptions)try{eval("extOptions = "+data.extendOptions)}catch(o){extOptions={},console.error(o)}if(data.mode.value==="builder")return e.preventDefault(),!1;let selector=e.currentTarget.getAttribute("href");if(selector.indexOf("#")===0&&selector!=="#"){let o=document.querySelector(selector+","+selector.replace("#","."));if(o)return o.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),e.preventDefault(),!1}if(data.type==="popup"){if(window.isPreviewTemplate){let l=data.el.querySelector(".beae-content-size-chart-preview");window.BeaePopupLibrary.createPopup(l,{id:data.id,...extOptions}),e.preventDefault();return}const o=window.createLoading(e.currentTarget);let r=(t=(n=window.BEAE_HELPER)==null?void 0:n.routes)==null?void 0:t.root_url;return window.BeaePopupLibrary.lightbox({id:data.id,url:(r!=="/"?r:"")+((data==null?void 0:data.url)??"").replace("/popup/","/?view=beae-"),...extOptions}).then(l=>{l.querySelector(".beae-product-form-next")&&window.handleEventFormProductCard(l),o.remove()}),e.preventDefault(),!1}else if(data.type==="pages"&&data.lightbox){let o=data.pageContent.replace(/&lt;/g,"<").replace(/&gt;/g,">").replace(/&amp;/g,"&").replace(/&quot;/g,'"').replace(/&#39;/g,"'");return window.isPreviewTemplate&&(o=data.el.querySelector(".beae-content-size-chart-preview")),window.BeaePopupLibrary.createPopup(o,{id:data.id,...extOptions}),e.preventDefault(),!1}}),data.type==="popup"&&data.lightbox&&new IntersectionObserver((t,o)=>{t.forEach(r=>{r.isIntersecting&&(o.unobserve(r.target),r.target.click())})}).observe(buttonElm) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-jbezt11r: ', ex)
      };
    }; if (window.BEAEBASE) {js_5BTSUHTI()} else {window.BEAEPAGEJS.push(js_5BTSUHTI)} })(); 